module.exports = __webpack_public_path__ + "img/star.e7409379.png";